type StatusLightProps = {
  state: 'on' | 'warn' | 'off'
  /** Optional accessible label. Only used by screen readers; never visible. */
  ariaLabel?: string
}

/**
 * The signature element. 6x6px dot, three states.
 * No tooltip, no explanation — dashboard-people recognize it.
 * `aria-label` is opt-in for screen readers; not rendered visually.
 */
export function StatusLight({ state, ariaLabel }: StatusLightProps) {
  return (
    <span
      className={`status-light ${state}`}
      role="presentation"
      aria-hidden={ariaLabel ? undefined : true}
      aria-label={ariaLabel}
    />
  )
}
